import React from 'react';
import Styles from '../../assets/css/components/company/company.module.scss';
import CompanyTable from '../company/CompanyList';
import { useNavigate } from 'react-router-dom';

const Company = () => {
  const navigate = useNavigate();

  return (
    <div className={`${Styles.company}`}>
      <div className={`${Styles.company_heading}`}>
        <h2>Company</h2>
        <button className={`${Styles.add_btn}`} onClick={() => navigate("/company/create")}>Add new Company</button>
      </div>

      <div className={`${Styles.cards}`}>
        <div className={`${Styles.card}`}>
          <p>Total customers</p>
          <h3>120</h3>
        </div>
        <div className={`${Styles.card}`}>
          <p>Total SKUs</p>
          <h3>716</h3>
        </div>
      </div>

      <div>
        <CompanyTable />
      </div>
    </div>
  )
}

export default Company

